import { render } from "./ComparisonCell.vue?vue&type=template&id=bbe1473e"
import script from "./ComparisonCell.vue?vue&type=script&lang=js"
export * from "./ComparisonCell.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__